import { useMemo } from 'react';
import { useBindViewer } from '../../hooks/useBindViewer';
import { canViewEhrPortal } from '../permissions';

export const useEhrPermissions = () => {
  const bindViewer = useBindViewer();

  return useMemo(
    () => ({
      canViewEhrPortal: bindViewer(canViewEhrPortal),
    }),
    [bindViewer],
  );
};
